import { render, staticRenderFns } from "./OptimizeAssetLocationButton.vue?vue&type=template&id=f3f0c66c&scoped=true&"
import script from "./OptimizeAssetLocationButton.vue?vue&type=script&lang=js&"
export * from "./OptimizeAssetLocationButton.vue?vue&type=script&lang=js&"
import style0 from "./OptimizeAssetLocationButton.vue?vue&type=style&index=0&id=f3f0c66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f0c66c",
  null
  
)

export default component.exports